import { Box } from "@mui/material";
import Libelle from "../../_i18n/fr.json";
import Layout from "../../components/Layout";
import Landing from "./Landing";
import styles from "./Landing/styles";

function LandingPage() {
  return (
    <Box sx={styles} className={"landingPage"}>
      <Layout title={Libelle.pageLanding.titre} noFollow>
        <Landing />
      </Layout>
    </Box>
  );
}

export default LandingPage;
